import Model, { attr, belongsTo } from '@ember-data/model';
import { cached } from '@glimmer/tracking';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class ClientPropertyModel extends Model {
  @attr('string') name!: string;

  @belongsTo('client', { inverse: 'clientProperties', async: false })
  client!: ModelRegistry['client'];

  @cached
  get hasOwner(): boolean {
    return !!this.client?.id;
  }

  @cached
  get property(): ModelRegistry['property'] {
    return this.store.peekRecord('property', this.id);
  }
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'client-property': ClientPropertyModel;
  }
}
